// import React, { useEffect , useRef} from 'react'
// import Sidebar from './Sidebar'
// import MessageContainer from './MessageContainer'
// import { useSelector ,useDispatch } from 'react-redux'
// import { useNavigate } from 'react-router-dom'
// import { logoutUser } from '../redux/userSlice' 

// const HomePage = () => {
//   const { authUser } = useSelector(store => store.user);
//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   const timeoutRef = useRef(null);


//   useEffect(() => {
//     if (!authUser) {
//       navigate("/guest");
//     }
//   }, [authUser, navigate]);

  
//   useEffect(() => {
  
//     if (!authUser?.isGuest) return;

//     const logoutDueToInactivity = () => {
//       dispatch(logoutUser());
//     };


//     const resetTimer = () => {
//       if (timeoutRef.current) {
//         clearTimeout(timeoutRef.current);
//       }
//       timeoutRef.current = setTimeout(logoutDueToInactivity, 5 * 60 * 1000); // 5 minutes
//     };

//     const events = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];
//     events.forEach(event => window.addEventListener(event, resetTimer));

//     resetTimer(); // Start timer when component mounts

//     return () => {
//       // Cleanup
//       events.forEach(event => window.removeEventListener(event, resetTimer));
//       if (timeoutRef.current) {
//         clearTimeout(timeoutRef.current);
//       }
//     };
//   }, [dispatch, authUser?.isGuest]);

//   // console.log("hii");
//   return (
   
   
//     <div className='flex w-full h-full bg-gray-400 bg-clip-padding backdrop-filter backdrop-blur-lg bg-opacity-0'>
//      {/* <div className='flex w-full h-[100dvh] bg-gray-400 bg-clip-padding backdrop-filter backdrop-blur-lg bg-opacity-0'> */}
//            {/* <Sidebar /> */}
//       {authUser?.isRole === 1 && <Sidebar />}
//       <MessageContainer />
//     </div>
//   )
// }

// export default HomePage




import React, { useEffect, useRef } from 'react'
import Sidebar from './Sidebar'
import MessageContainer from './MessageContainer'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { logoutUser } from '../redux/userSlice'
import useWindowSize from '../hooks/useWindowSize' // New hook

const HomePage = () => {
  const { authUser, selectedUser } = useSelector(store => store.user)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const timeoutRef = useRef(null)
  const { width } = useWindowSize()
  const isMobile = width < 768

  useEffect(() => {
    if (!authUser) {
      navigate("/guest")
    }
  }, [authUser, navigate])

  useEffect(() => {
    if (!authUser?.isGuest) return

    const logoutDueToInactivity = () => {
      dispatch(logoutUser())
    }

    const resetTimer = () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
      timeoutRef.current = setTimeout(logoutDueToInactivity, 5 * 60 * 1000)
    }

    const events = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart']
    events.forEach(event => window.addEventListener(event, resetTimer))

    resetTimer()

    return () => {
      events.forEach(event => window.removeEventListener(event, resetTimer))
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [dispatch, authUser?.isGuest])

  return (
    <div className='flex w-full h-full bg-gray-400 bg-clip-padding backdrop-filter backdrop-blur-lg bg-opacity-0'>
      {authUser?.isRole === 1 && (
        /* Desktop Sidebar */
        !isMobile && <Sidebar />
      )}
      
      {authUser?.isRole === 1 ? (
        isMobile ? (
          selectedUser ? (
            <MessageContainer />
          ) : (
            <Sidebar />
          )
        ) : (
          <MessageContainer />
        )
      ) : (
        <MessageContainer />
      )}
    </div>
  )
}

export default HomePage






